import { Button } from "@aidron/aidron-ds";
import styled from "styled-components";
import { ReactComponent as Stock } from "../../../assets/image/in-stock.svg";
import { ReactComponent as Sale } from "../../../assets/image/profits.svg";

export const Container = styled.div`
  display: grid;
  grid-template-columns: ${({ sixthColumn }) => (sixthColumn ? "30% 1fr 0.7fr 1fr 0.5fr 0.5fr" : "30% repeat(3, 1fr) 10%")};
  height: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const Item = styled.div`
  padding: 0 20px;
  text-align: ${({ textAlign }) => (textAlign ? "center" : "default")};
  border-right: ${({ border }) => (border ? "solid 1px #919191" : "none")};
  position: relative;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LastColumnsItems = styled.div`
  display: flex;
`;

export const ItemImage = styled.div`
  padding: 0 10px;
  text-align: ${({ textAlign }) => (textAlign ? "center" : "default")};
  border-right: ${({ border }) => (border ? "solid 1px #919191" : "none")};
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 40px;
  align-items: center;
`;

export const ButtonAccordion = styled(Button)`
  position: absolute;
  bottom: -10px;
  left: 41%;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 20px;
`;

const IconStyling = `
  width: 50px;
  height: 50px;
  fill: #f26f21;
  @media (max-width: 980px) {
    display: none;
  }
`;

export const StockIcon = styled(Stock)`
  ${IconStyling}
`;

export const SaleIcon = styled(Sale)`
  ${IconStyling}
`;

export const Section = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
`;

export const ChartContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  margin: 1rem;
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`;

export const IndexesSection = styled.div`
  display: flex;
  justify-content: space-around;
  margin-right: 1.5rem;
`;

export const OuterContainerAnalysysButton = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 0.5rem;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const OuterButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

export const OuterContainerCarousel = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const InnerContainerCarousel = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
`;

export const CardOutFill = styled.div`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  padding: 16px;
  border: 1px solid #bbbcbd;
`;

export const OuterContainerActionModal = styled.div`
  margin-left: 2rem;
  margin-right: 2rem;
  margin-bottom: 1.5rem;
`;

export const OptionContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const FinishButtonContainer = styled.div`
  display: flex;
  justify-content: end;
`;

export const ConfirmationButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
`;

export const TextAreaOuterContainer = styled.div`
  margin-left: 2.5rem;
`;

export const TextAreaInnerContainer = styled.div`
  max-width: 600px;
`;

export const TextArea = styled.textarea`
  width: 100%;
`;